(function () {
  'use strict';

  if (window.PGCheckoutUploadGuardV58) return;
  window.PGCheckoutUploadGuardV58 = true;

  var CART_ROOT = [
    '.cart_content',
    '#pg-cart',
    '.ecom-ajax-cart',
    '.mini-cart',
    '.side-cart',
    '.cart-drawer',
    '[data-cart-drawer]',
    '[data-cart-content]'
  ].join(',');

  var UPLOAD_BRIDGE_CONTROL = [
    '.add_to_cart',
    '.ajax-submit',
    '.pg-cfg-next--atc',
    'button[name="add"]'
  ].join(',');

  document.addEventListener('click', function (event) {
    var target = event.target;
    var control = target && target.closest ? target.closest(UPLOAD_BRIDGE_CONTROL) : null;
    if (!control || !control.closest || !control.closest(CART_ROOT)) return;

    var uploads = window.PGUploadsV51;
    if (!uploads) return;

    var previousForwarding = Boolean(uploads.forwarding);
    uploads.forwarding = true;

    window.setTimeout(function () {
      if (window.PGUploadsV51 === uploads) uploads.forwarding = previousForwarding;
    }, 0);
  }, true);
})();
